/* pdp-social-proof.js */

(function () {
  'use strict';

  /* ── Mulberry32 — fast seeded PRNG, no deps ─────────────────────────── */
  function mulberry32(seed) {
    seed = seed >>> 0;
    return function () {
      seed += 0x6D2B79F5;
      var t = seed;
      t = Math.imul(t ^ (t >>> 15), t | 1);
      t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }

  /* ── djb2 hash — string → unsigned 32-bit int ───────────────────────── */
  function hashStr(s) {
    var h = 5381;
    for (var i = 0; i < s.length; i++) {
      h = (Math.imul(h, 33) ^ s.charCodeAt(i)) | 0;
    }
    return h >>> 0;
  }

  /* ── Integer in [min, max] inclusive ────────────────────────────────── */
  function inRange(rng, min, max) {
    if (min >= max) return min;
    return Math.floor(rng() * (max - min + 1)) + min;
  }

  /**
   * Persistent visitor ID
   * ─────────────────────
   * 1st choice : localStorage  — survives refreshes + tab close + same browser session
   * 2nd choice : sessionStorage — survives refresh, cleared when tab closes
   * 3rd choice : in-memory      — same number for the page session only
   * (covers private/incognito where storage may be blocked)
   */
  function getVisitorId() {
    var KEY = '_24dx_vid';
    try {
      var id = localStorage.getItem(KEY);
      if (!id) {
        id = Math.random().toString(36).slice(2, 10) +
             Date.now().toString(36);
        localStorage.setItem(KEY, id);
      }
      return id;
    } catch (lsErr) {
      try {
        var sid = sessionStorage.getItem(KEY);
        if (!sid) {
          sid = Math.random().toString(36).slice(2, 10);
          sessionStorage.setItem(KEY, sid);
        }
        return sid;
      } catch (ssErr) {
        if (!window.__24dxVid) {
          window.__24dxVid = Math.random().toString(36).slice(2, 10);
        }
        return window.__24dxVid;
      }
    }
  }

  /* ── Today key — changes at local midnight, same for all visitors ───── */
  function todayKey() {
    var d = new Date();
    return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
  }

  /**
   * Orders count — never goes down for a returning visitor.
   *
   * The deterministic daily seed ensures all first-time visitors see the
   * same count on the same day. localStorage makes it monotonic: if
   * tomorrow's seed produces a lower number than what this visitor already
   * saw, we floor at the stored value so the count only ever stays the
   * same or increases.
   */
  function getOrders(pid, oMin, oMax, today) {
    var KEY = '_24dx_ord_' + pid;
    var rng        = mulberry32(hashStr(pid + ':' + today + ':orders'));
    var todayCount = inRange(rng, oMin, oMax);
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) {
        localStorage.setItem(KEY, JSON.stringify({ date: today, count: todayCount }));
        return todayCount;
      }
      var stored = JSON.parse(raw);
      if (stored.date === today) {
        return stored.count;
      }
      var newCount = Math.max(todayCount, stored.count);
      localStorage.setItem(KEY, JSON.stringify({ date: today, count: newCount }));
      return newCount;
    } catch (e) {
      return todayCount;
    }
  }

  /* ── Main run function ───────────────────────────────────────────────── */
  function run() {
    var vid   = getVisitorId();
    var today = todayKey();

    /* Stock urgency counters ─────────────────────────────────────────── */
    document.querySelectorAll('[data-pdp-stock]').forEach(function (el) {
      if (el.getAttribute('data-sp-use-real') === 'true') return;

      var pid  = el.getAttribute('data-pdp-stock');
      var min  = parseInt(el.getAttribute('data-sp-min'), 10);
      var max  = parseInt(el.getAttribute('data-sp-max'), 10);

      if (isNaN(min) || isNaN(max)) return;

      var rng = mulberry32(hashStr(pid + ':' + vid + ':stock'));
      var num = inRange(rng, min, max);

      var span = el.querySelector('[data-sp-stock-count]');
      if (span) span.textContent = num;
    });

    /* Viewers + orders counters ─────────────────────────────────────── */
    document.querySelectorAll('[data-pdp-viewers]').forEach(function (el) {
      var pid  = el.getAttribute('data-pdp-viewers');
      var vMin = parseInt(el.getAttribute('data-sp-v-min'), 10);
      var vMax = parseInt(el.getAttribute('data-sp-v-max'), 10);
      var oMin = parseInt(el.getAttribute('data-sp-o-min'), 10);
      var oMax = parseInt(el.getAttribute('data-sp-o-max'), 10);

      if (isNaN(vMin) || isNaN(vMax) || isNaN(oMin) || isNaN(oMax)) return;

      /* Viewers: stable per visitor × product */
      var vRng    = mulberry32(hashStr(pid + ':' + vid + ':viewers'));
      var viewers = inRange(vRng, vMin, vMax);

      /* Orders: monotonically non-decreasing for returning visitors */
      var orders = getOrders(pid, oMin, oMax, today);

      var vEl = el.querySelector('[data-sp-viewers-count]');
      var oEl = el.querySelector('[data-sp-orders-count]');
      if (vEl) vEl.textContent = viewers;
      if (oEl) oEl.textContent = orders;
    });
  }

  /* ── Bootstrap ──────────────────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  /* Theme Editor — re-run when any section is reloaded or reordered */
  document.addEventListener('shopify:section:load',    run);
  document.addEventListener('shopify:section:reorder', run);

}());
